import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68708476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete-dialog" }
const _hoisted_2 = { class: "delete-dialog__body" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "delete-dialog__body-content"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "delete-dialog__footer" }
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = ["onClick", "loading"]
const _hoisted_15 = ["onClick"]

import { ref, onMounted } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'

interface IProps {
  title?: string
  subTitle?:string
  maskClosable?: boolean
  content?: string
  hasCheck?: boolean
  cancelText?: string
  onCalcel?: (checked: boolean) => void
  okText?: string
  onOk?: (checked: boolean) => void|Promise<string|null>
  loadingText?: string
}

interface IEmit {
  (e: 'dialog-close'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    subTitle: null,
    maskClosable: { type: Boolean },
    content: null,
    hasCheck: { type: Boolean },
    cancelText: null,
    onCalcel: null,
    okText: null,
    onOk: null,
    loadingText: null
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title?: string
  subTitle?:string
  maskClosable?: boolean
  content?: string
  hasCheck?: boolean
  cancelText?: string
  onCalcel?: (checked: boolean) => void
  okText?: string
  onOk?: (checked: boolean) => void|Promise<string|null>
  loadingText?: string
}




const isMountedRef = ref(false)
const isLoading = ref(false)
const checked = ref(false)
const errorMessage = ref('')

const { close } = usePromisifyDialog(emit)
const noop = () => {}
const handleClose = () => {
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

const handleToggleChecked = () => {
  if (!props.hasCheck) return
  checked.value = !checked.value
}

const handleOnOk = async () => {
  let returnVal
  isLoading.value = true
  try {
    if (typeof props.onOk === 'function') {
      const ret = props.onOk(checked.value)
      if (ret instanceof Promise) {
        returnVal = await ret
        errorMessage.value = returnVal
      }
    }
  } catch (err) {
    console.log('err', err)
  }
  isLoading.value = false
  if (!returnVal) handleClose()
}

const handleOnCancel = () => { 
  if (typeof props.onCalcel === 'function') props.onCalcel(checked.value)
  handleClose()
}

onMounted(() => {
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper pop-wrapper-as delete-modal", { 'is-mounted': isMountedRef.value }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (!props.maskClosable ? noop : handleClose), ["self","stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(props.title), 1),
          (props.subTitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(props.subTitle), 1))
            : _createCommentVNode("", true),
          _createElementVNode("i", {
            class: "icomoon-close",
            onClick: _withModifiers(handleClose, ["stop"])
          }, null, 8, _hoisted_5),
          (props.content)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (props.hasCheck)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!checked.value)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "icomoon-checkbox",
                            onClick: handleToggleChecked
                          }))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "icomoon-checkbox-checked",
                            onClick: _withModifiers(handleToggleChecked, ["stop"])
                          }, _hoisted_10, 8, _hoisted_7))
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  onClick: _withModifiers(handleToggleChecked, ["stop"])
                }, _toDisplayString(props.content), 9, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("a", {
            class: "ok-btn",
            onClick: _withModifiers(handleOnOk, ["stop"]),
            loading: isLoading.value
          }, _toDisplayString(isLoading.value ? props.loadingText : props.okText), 9, _hoisted_14), [
            [_vShow, props.okText]
          ]),
          _createElementVNode("a", {
            class: "cancel-btn",
            onClick: _withModifiers(handleOnCancel, ["stop"])
          }, _toDisplayString(props.cancelText), 9, _hoisted_15)
        ])
      ])
    ], 2)
  ]))
}
}

})